export default class TwoColumnTextBlock {
  constructor(el) {
    this.$this = $(el);
    this.$bodyElement = this.$this.find('.gravity-two-column-text-block__body');
    this.$readMoreButton = this.$this.find('.read-more-button');
    this.maxHeight = 211;
    this.resizeTimer = null;

    // Class names constants
    this.classes = {
      showLessContent: 'show-less-content',
      hidden: 'hidden'
    };

    // Text constants
    this.texts = {
      readMore: 'Read More',
      readLess: 'Read Less'
    };
  }

  init() {
    if (this.$bodyElement.length) {
      this.checkContentHeight();
      this.handleResize();
    }
  }

  checkContentHeight() {
    if (!this.$bodyElement.length) return;

    // Get the actual content height
    const contentHeight = this.$bodyElement[0].scrollHeight;
    
    // Check if user has manually expanded content
    const showContent = this.$bodyElement.data('show-content') === true;

    if (contentHeight > this.maxHeight) {
      // Only add show-less-content class if user hasn't manually expanded content
      if (!showContent) {
        this.$bodyElement.addClass(this.classes.showLessContent);
        this.$bodyElement.data('show-content', false);
      }

      // Remove hidden class from button if it exists
      if (this.$readMoreButton.length) {
        this.$readMoreButton.removeClass(this.classes.hidden);
        this.bindReadMoreClick();
      }
    } else {
      // Remove show-less-content class if it exists
      if (this.$bodyElement.hasClass(this.classes.showLessContent)) {
        this.$bodyElement.removeClass(this.classes.showLessContent);
      }
      // Reset data attribute
      this.$bodyElement.data('show-content', true);
      
      // Add hidden class to button if it exists
      if (this.$readMoreButton.length) {
        this.$readMoreButton.addClass(this.classes.hidden);
      }
    }
  }

  bindReadMoreClick() {
    // Remove any existing click handlers to avoid duplicates
    this.$readMoreButton.off('click.readMore');
    
    // Add click handler for read more functionality
    this.$readMoreButton.on('click.readMore', () => {
      if (this.$bodyElement.hasClass(this.classes.showLessContent)) {
        this.$bodyElement.removeClass(this.classes.showLessContent);
        this.$readMoreButton.text(this.texts.readLess);
        // Set data attribute to indicate user has manually expanded content
        this.$bodyElement.data('show-content', true);
      } else {
        this.$bodyElement.addClass(this.classes.showLessContent);
        this.$readMoreButton.text(this.texts.readMore);
        // Set data attribute to indicate content is collapsed
        this.$bodyElement.data('show-content', false);
      }
    });
  }

  handleResize() {
    $(window).on('resize', () => {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        this.checkContentHeight();
      }, 250);
    });
  }
}

// Initialize for each block instance
$('.gravity-two-column-text-block').each((_index, el) => {
  new TwoColumnTextBlock(el).init();
});
